<template>
  <div class="wrapBox">
    <div class="callBox">
      <p class="yesImg"></p>
      <p class="yesText">支付成功</p>
      <p class="showText">
        恭喜您！选房成功！请耐心等待,您的置业顾问正在为您准备合约。请留意短信通知。
      </p>
      <div class="saleInfo">
        <p class="saleInfoBox">
          <img :src="saleImg" alt="" />
          {{ saleName }}
        </p>
        <p class="callSale" @click="callSalePhone">
          一键拨打&nbsp;&nbsp;{{ saleMobile }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import util from "@/utils/utils";
import * as comreq from "@/utils/comreq";
import { MessageBox } from "mint-ui";
import request from "@/utils/request";
import wxsdk from "@/utils/wxsdk";
import Cookies from "js-cookie";
import "./components/all.css";
export default {
  components: {},
  data() {
    return {
      openid: Cookies.get("openid"),
      projectId: this.$route.query.pid ? parseInt(this.$route.query.pid) : 2343,
      saleImg: "",
      saleName: "",
      saleMobile: "",
      shareProjectName: ""
    };
  },
  methods: {
    getSaleData() {
      let that = this;
      request
        .get(that.global.API_URL, {
          action: "/dhyx/DhProjectSalespersonAction/getSPUserInfoByOpenid",
          requestParam: { projectId: that.projectId }
        })
        .then(function(data) {
          console.log(data.obj);
          that.saleImg = data.obj.salerheadimg;
          that.saleName = data.obj.salername;
          that.saleMobile = data.obj.salermobile;
        });
    },
    // 给销售员打电话
    callSalePhone() {
      let that = this;
      location.href = `tel:${that.saleMobile}`;
    },
    // 获取配置i信息
    getConfig() {
      let that = this;
      request
        .get(that.global.API_URL, {
          action: "/house/HouseOnlineAction/getConfig",
          requestParam: { projectId: that.projectId }
        }).then(function(data) {
          console.log(data.obj);
          that.shareProjectName = data.obj.name;
          that.shareInit();
        })
    },
    shareInit(){
      let that = this;
      //设置分享
      that.global.SHARE_TITLE = `${that.shareProjectName}售楼中心，线上看房，实时咨询，欢迎您的光临！`;
      that.global.SHARE_DESC = `美好人居，一触即达。帮忙传播，更有多重惊喜哟！`;
      that.global.SHARE_IMG_URL =
        "http://assets.rurushishi.com/yq-rs-make/huafasubscription/hfrgShare.jpg";
      let shareLink = `${location.protocol}//${location.host}/h5/huafasubscription/housePage?pid=${this.projectid}&refereeopenid=${
        this.shareSpreadInfo.refereeopenid
      }`;
      console.log(shareLink)
      that.global.SHARE_LINK = shareLink;
      wxsdk.init();
    }
  },
  mounted() {
    let that = this;
    that.getConfig();
    that.getSaleData();
    comreq.getUserInfo().then(function(userInfo) {
      console.log(userInfo);
    });
  }
};
</script>
<style lang="stylus" scoped>
.wrapBox {
  width: 100%;
  height: 100%;
  position: relative;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
.callBox{
  width 100%
  height 100%
  position fixed
  left 0
  top 0
  background white
}
.yesImg{
  width 1.16rem
  height 1.16rem
  background url('http://assets.rurushishi.com/yq-rs-make/huafasubscription/yes.png') no-repeat center
  background-size 100% 100%
  margin 1.6rem auto .44rem
}
.yesText{
  width 100%
  font-size .38rem
  color #5DAE72
  line-height .53rem
  text-align center
  margin-bottom .58rem
}
.showText{
  width 5.5rem
  color #333333
  line-height .38rem
  margin 0 auto
  margin-bottom .58rem
}
.saleInfo{
  width 6.26rem
  padding .33rem
  box-sizing border-box
  border 1px solid #5DAE72
  border-radius 10px
  margin 0 auto
}
.saleInfoBox img{
  width .68rem
  height .68rem
  border-radius 50%
  margin-right .1rem
}
.callSale{
  width 5.5rem
  height .88rem
  line-height .88rem
  background url('http://assets.rurushishi.com/yq-rs-make/huafasubscription/call.png') no-repeat .7rem center #1959A7
  background-size .32rem .32rem
  border-radius 10px
  margin-top .33rem
  color white
  text-indent 1.5rem
}
</style>
